export enum SD_Roles {
    OWNER = "owner",
    ADMIN = "admin",
    EMPLOYEE = "employee",
    VIEWER = "viewer",
};